export default {"src":"/_next/static/media/bg_purple.f1fea6e9.svg","height":605,"width":2200,"blurWidth":0,"blurHeight":0};